import React from 'react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-16 px-4 bg-cream" data-id="element-41">
      <div className="max-w-[520px] mx-auto bg-white border border-accent/30 p-6 md:p-8 text-center shadow-sm relative" data-id="element-42">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white px-4 py-1 text-[10px] font-bold uppercase tracking-widest" data-id="element-43">
          Mi promesa personal
        </div>

        <h2 className="text-[24px] font-bold text-primary-dark mb-4 mt-2" data-id="element-44">
          Garantía «Formulá o te devuelvo»
        </h2>

        <p className="text-[16px] italic text-muted leading-[1.6] mb-4" data-id="element-45">
          Si en los primeros 7 días abrís el sistema y no encontrás valor real —
          ni una fórmula que valga lo que pagaste — me escribís un email y te
          hago el reembolso completo. Sin formularios. Sin preguntas. Sin drama.
        </p>

        <p className="text-[16px] italic text-muted leading-[1.6] mb-6" data-id="element-46">
          Esta garantía existe porque el contenido habla por sí solo. No tenés
          nada que perder. Solo fórmulas que ganar.
        </p>

        <p className="text-[16px] font-bold text-pain" data-id="element-47">
          Sin preguntas. Sin formularios. Solo un email.
        </p>
      </div>
    </section>;
}